import {
	createEntityAdapter,
	createSlice,
	type WithSlice,
} from '@reduxjs/toolkit'

import type { Poi } from '@common/types/Poi'
import { reducer } from './store'

const poiAdapter = createEntityAdapter({
	selectId: (poi: Poi) => poi.id,
	sortComparer: (a, b) => a.id.localeCompare(b.id),
})

const { selectById, selectIds, selectEntities } = poiAdapter.getSelectors()

declare module './store' {
	// eslint-disable-next-line @typescript-eslint/no-empty-object-type
	export interface LoadedSlices extends WithSlice<typeof poiSlice> {}
}

export type PoiSlice = ReturnType<(typeof poiSlice)['getInitialState']>
export const poiSlice = createSlice({
	name: 'pois',
	initialState: poiAdapter.getInitialState(),
	reducers: {
		setPoi: poiAdapter.setOne,
		setPois: poiAdapter.setMany,

		delPoi: poiAdapter.removeOne,
		delPois: poiAdapter.removeMany,

		insertPois: poiAdapter.addMany,
	},
	selectors: {
		getPoi: (state, id: string): Poi | undefined => selectById(state, id),
		listPois: selectIds,
		getAllPois: selectEntities,
	},
})

export const {
	reducer: poisReducer,
	actions: { setPoi, setPois, delPoi, delPois, insertPois },
	selectors: { getPoi, listPois, getAllPois },
} = poiSlice.injectInto(reducer)
